export function scrollToId(id, behavior = "smooth") {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior, block: "start" });
  }
}
